<div class="wrapper">
    <div class="container spacer-top mt-5">
        <button aria-label="Zurück"
            mat-icon-button
            (click)="back()">
            <mat-icon fontSet="material-symbols-outlined">arrow_back</mat-icon>
        </button>
        <h2>Third-Party Licenses</h2>

        @if (loading()) {
            <div class="loading">
                Loading licenses...
            </div>
        }

        @if (error()) {
            <div class="error">
                Licenses could not be loaded. They are only available in production
                builds.
            </div>
        }

        @if (!loading() && !error()) {
            <mat-accordion multi>
                @for (license of licenses(); track license.packageName) {
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ license.packageName }}
                            </mat-panel-title>
                            <mat-panel-description>
                                {{ license.licenseType }}
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <pre class="license-text">{{ license.licenseText }}</pre>
                    </mat-expansion-panel>
                }
            </mat-accordion>
        }
    </div>
</div>
